import Modernizr from "modernizr";

const browserCapabilities = {
  start() {
    this.gap()
  },
  gap () {
    Modernizr.addTest('no-gap', () => {
      const element = document.createElement('div')
      element.style.display = 'flex'
      element.style.gap = '1px'
      return element.style.gap === '1px'
    })

    Modernizr.on('no-gap', (result) => {
      if (result) {
        document.documentElement.classList.remove('no-gap')
      }
    })
  }
}

export default browserCapabilities